import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./SplitLanding.css";

function SplitLanding() {
  const navigate = useNavigate();
  const [hoveredSide, setHoveredSide] = useState(null);

  const handleNextGenClick = () => {
    window.open("http://152.42.225.142:3001", "_blank");
  };

  const handleMyAiClick = () => {
    navigate("/myai");
  };

  return (
    <div className="split-landing-page">
      {/* Header with MyAi Logo - Parent Brand */}
      <div className="split-landing-header">
        <div className="header-logo-container">
          <img src="/HDASLogo.png" alt="HDAS Logo" className="header-logo-img" />
          <span className="header-logo-text">MyAi</span>
        </div>
        <div className="header-tagline">Healthcare Technology Solutions</div>
      </div>

      {/* Content Container */}
      <div className="split-landing-content">
        {/* Left Side - NextGen OncoData Registry */}
        <div
          className={`landing-side nextgen-side ${hoveredSide === "nextgen" ? "hovered" : ""}`}
          onMouseEnter={() => setHoveredSide("nextgen")}
          onMouseLeave={() => setHoveredSide(null)}
          onClick={handleNextGenClick}
        >
          <div className="side-overlay"></div>
          <div className="side-content">
            <div className="side-header">
              <div className="product-badge">A MyAi Product</div>
              <h1 className="side-title">NextGen OncoData Registry</h1>
              <p className="side-subtitle">Cloud-Native Cancer Registry & Research Platform</p>
            </div>
          
          <div className="side-description">
            <p className="description-text">
              NextGen OncoData Registry is a cloud-native cancer registry and research platform designed to accelerate 
              oncology research through structured registry data, AI-powered analytics, and secure collaboration.
            </p>
            
            <div className="features-list">
              <div className="feature-point">
                <span className="feature-icon">&#10003;</span>
                <span>ICD-11-coded cancer registry with intelligent data extraction</span>
              </div>
              <div className="feature-point">
                <span className="feature-icon">&#10003;</span>
                <span>HIPAA-compliant anonymization and role-based access control</span>
              </div>
              <div className="feature-point">
                <span className="feature-icon">&#10003;</span>
                <span>ML Training Lab with Jupyter-based environment</span>
              </div>
              <div className="feature-point">
                <span className="feature-icon">&#10003;</span>
                <span>Real-time analytics, survival curves, and trend visualizations</span>
              </div>
              <div className="feature-point">
                <span className="feature-icon">&#10003;</span>
                <span>Governed approval workflow for secure dataset access</span>
              </div>
            </div>

            <div className="side-footer">
              <button className="side-button">
                Access NextGen Registry
                <span className="button-arrow">&rarr;</span>
              </button>
            </div>
          </div>
        </div>
        <div className="tech-pattern tech-pattern-left"></div>
      </div>

        {/* Divider */}
        <div className="landing-divider">
          <div className="divider-line"></div>
          <div className="divider-text">OR</div>
          <div className="divider-line"></div>
        </div>

        {/* Right Side - HDAS */}
        <div
          className={`landing-side hdas-side ${hoveredSide === "hdas" ? "hovered" : ""}`}
          onMouseEnter={() => setHoveredSide("hdas")}
          onMouseLeave={() => setHoveredSide(null)}
          onClick={handleMyAiClick}
        >
          <div className="side-overlay"></div>
          <div className="side-content">
            <div className="side-header">
              <div className="product-badge">A MyAi Product</div>
              <h1 className="side-title">HDAS</h1>
              <p className="side-subtitle">Healthcare Data Analysis Made Simple</p>
            </div>
          
            <div className="side-description">
              <p className="description-text">
                MyAi is an automated machine learning platform designed specifically for healthcare professionals and students. 
                Transform your raw healthcare data into actionable insights with zero coding required.
              </p>
              
              <div className="features-list">
                <div className="feature-point">
                  <span className="feature-icon">&#10003;</span>
                  <span>No-code automated machine learning platform</span>
                </div>
                <div className="feature-point">
                  <span className="feature-icon">&#10003;</span>
                  <span>Intelligent data cleaning and preprocessing</span>
                </div>
                <div className="feature-point">
                  <span className="feature-icon">&#10003;</span>
                  <span>Advanced ML algorithms for classification and regression</span>
                </div>
                <div className="feature-point">
                  <span className="feature-icon">&#10003;</span>
                  <span>Publication-ready visualizations and reports</span>
                </div>
                <div className="feature-point">
                  <span className="feature-icon">&#10003;</span>
                  <span>Secure and private healthcare data processing</span>
                </div>
              </div>

              <div className="side-footer">
                <button className="side-button">
                  Access HDAS Platform
                  <span className="button-arrow">&rarr;</span>
                </button>
              </div>
            </div>
          </div>
          <div className="tech-pattern tech-pattern-right"></div>
        </div>
      </div>
    </div>
  );
}

export default SplitLanding;

